import React, { useState } from "react";
import Button from "../../components/Button/Button";
import BackButton from "../../components/BackButton/BackButton";

function ButtonsConditions({ onSelect, onBack }) {
  const [selectedCondition, setSelectedCondition] = useState(null);

  const conditions = [
    {
      id: 1,
      name: "✅ Sí",
      value: true,
    },
    {
      id: 2,
      name: "❌ No",
      value: false,
    },
  ];

  const handleSelect = (value) => {
    setSelectedCondition(value);
    onSelect(value);
  };

  return (
    <div className="goodCondition">
      <h2>¿Encienden y funcionan todos los botones?</h2>
      <div className="buttonsContainer">
        {conditions.map((item) => (
          <Button
            key={item.id}
            type={selectedCondition === item.value ? "fullBlack" : "full"} // Estilo dinámico
            onClick={() => handleSelect(item.value)}
          >
            {item.name}
          </Button>
        ))}
      </div>
      {/* <BackButton onClick={onBack} /> */}
    </div>
  );
}

export default ButtonsConditions;
